export default "__VITE_ASSET__DTO_6jz5__"